import Vue from 'vue'

export const fetchActiveAlarms = ({ state, commit }) => {
    return Vue.prototype.$rest.get("/user/" + state.user.id + "/active-alarms").then(function (content) {
        //commit("setAlarms", content.data)
        console.log(content.data)
    })
};

// Alarm rules
export const updateAlarmRules = ({ state, commit }, {serial, rules}) => {
    let data = [];

    for(var i = 0; i < rules.length; i++)
    {
        data[i] = {
            weekday: i,
            to: [rules[i].to.HH, rules[i].to.mm, "00"].join(":"),
            from: [rules[i].from.HH, rules[i].from.mm, "00"].join(":"),
            phone_enabled: rules[i].sms,
            email_enabled: rules[i].email,
        }
    }

    return Vue.prototype.$rest.post("/sensor/" + serial + "/alarm-rules", {rules: data});
};


// WEBPACK FOOTER //
// ./src/store/actions/alarms.js